import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { LoaderService } from '@app/core/services/loader.service';
import { ILoaderState } from '@app/shared/models/ILoaderState';

@Component({
    selector: 'app-header-loader',
    // template: '<div [class.loader-hidden]="!show" class="header-loader"><img src="assets/img/preloader.svg" width="40" height="40"></div>',
    templateUrl: 'loader.component.html',
    styleUrls: ['loader.component.scss']
})
export class HeaderLoaderComponent implements OnInit {

  show = false;
  public options = {
    min: 8,
    max: 100,
    ease: 'linear',
    speed: 200,
    trickleSpeed: 300,
    meteor: true,
    spinner: false,
    direction: 'ltr+',
    color: 'black',
    thick: false
  };

  private subscription: Subscription;

  @ViewChild('progressBar') progressBar: any;

  constructor(private loaderService: LoaderService) { }
  ngOnInit() {
    this.subscription = this.loaderService.loaderState
      .subscribe((state: ILoaderState) => {

        // if(!state.show){
        //   // setTimeout(val=>{this.show = state.show},1500);
        //   console.log('starting', this.progressBar.isStarted)
        //   this.show = state.show;
        //   if(!this.progressBar.isStarted)
        //     this.progressBar.start();
        // }else{
        //   this.show = state.show;
        //   setTimeout(val=>{this.progressBar.complete()},1500);
        //   //this.progressBar.complete();
        // }
        if(state.show){
          if(!this.progressBar.isStarted)
            this.progressBar.start();
        }else{
          setTimeout(val=>{this.progressBar.complete()},1500);
        }
      });
  }
  // ngOnInit() {
  //   console.log(this.options, 'OPTIONS')
  // this.subscription = this.loaderService.loaderState
  //   .subscribe((state: ILoaderState) => {
  //     this.show = state.show;
  //     if(state.show)
  //       this.progressBar.start();
  //     else
  //       this.progressBar.complete();
  //   });
  // }

  onStarted() {

    //this.show = true;
    // setTimeout(() => {
    //   this.startedClass = false;
    // }, 800);
  }

  onCompleted() {
    
    //this.show = false;
    // setTimeout(() => {
    //   this.completedClass = false;
    // }, 800);
  }
    ngOnDestroy() {
      this.subscription.unsubscribe();
    }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/pmclient-uat/src/app/shared/components/loader/header-loader.component.ts